<template>


  <VueFinalModal v-model="showEspecialidad" :esc-to-close="false" :click-to-close="false" :prevent-click="false"
    class="modal-container" content-class="modal-content2">

    <h4>Escoja la especialidad para Iniciar</h4>

    <div class="modal__content">
      <label for="especialidad">Especialidad:</label>
      <select v-model="selectedEspecialidad" id="especialidad" class="form-select">
        <option v-for="especialidad in especialidades" :key="especialidad.codigo" :value="especialidad.name">
          {{ especialidad.name }}
        </option>
      </select>

      <div class="modal__action">
        <button type="button" id="btn-terms" class="btn btn-primary mt-3" @click="confirmar" style="width: 100%"
          :disabled="!selectedEspecialidad">
          Aceptar
        </button>
      </div>
    </div>


  </VueFinalModal>



  <div class="login-form">
    <h5 class="login-form__title">Ingreso a la Plataforma</h5>

    <p class="login-form__hint" @mouseover="tooltipShow = true" @mouseleave="tooltipShow = false">
      ¿Eres nuevo?
      <i class="fa-solid fa-circle-info"></i>
      <span v-if="tooltipShow" class="login-form__tooltip">Cuando inicies sesión con Google o Microsoft por primera vez, te
        registraremos automáticamente.</span>
    </p>

    <form role="form" autocomplete="off" @submit.prevent="onSubmitSesion">
      <div class="mb-2">
        <input v-model="user.email" placeholder="Ingrese su email" class="form-control" required type="email"
          autocomplete="off" @blur="validateEmail" />
        <small v-if="emailError" class="text-danger">
          {{ emailError }}
        </small>
      </div>

      <div class="mb-3">
        <input placeholder="Ingrese su contraseña" v-model="user.contrasena" class="form-control" required
          type="password" autocomplete="off" />
      </div>

      <argon-button id="log-in" ref="log-in" type="submit" class="login-form__submit mt-1" variant="gradient"
        color="success" fullWidth size="lg">{{ textoButton }}
      </argon-button>
    </form>
  </div>


</template>

<script>
/*eslint-disable */
import ArgonButton from "@/components/ArgonButton.vue";

import { VueFinalModal } from "vue-final-modal";
import "vue-final-modal/style.css";
import Tooltip from "../components/Tooltip.vue";
import { JSEncrypt } from "jsencrypt";
import keys from "@/store/keys";

export default {
  name: "formulario",
  components: {
    ArgonButton,
    VueFinalModal,
    Tooltip,
  },
  props: ["promoCode", "textoButton", "isLogin"],
  data() {
    return {
      user: {
        contrasena: "",
        email: "",
      },
      emailError: "",
      isDisabled: false,
      acceptingEspecialidad: false,
      showEspecialidad: false,
      countryCode: "",
      tooltipShow: false,
      especialidades: [], // Almacena las especialidades obtenidas
      selectedEspecialidad: "", // Especialidad seleccionada
      rol: ""
    };
  },
  watch: {},
  computed: {},

  methods: {

    validateEmail() {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      this.emailError = regex.test(this.user.email) ? "" : "Correo electrónico inválido";
    },
    onInputChange() {
      this.user.dni = this.user.dni.replace(/\D/g, "").slice(0, 10);
    },

    async onSubmitSesion() {
      try {

        const response = await this.$https.post("/acceso/login", this.user);

        if (response.data.code === 200) {

          if (response.data.datos.update === 0) {
            localStorage.setItem('userData', JSON.stringify(response.data.datos))
            this.$router.push({ name: 'password' })
          } else {

            this.especialidades = response.data.datos.especialidades || []; // Carga especialidades
            this.rol = this.$encryptBackoffice.encrypt(response.data.rol)

            // Si hay especialidades, selecciona la primera por defecto
            if (this.especialidades.length > 0) {
              this.selectedEspecialidad = this.especialidades[0].name;
            }

            this.showEspecialidad = true

            // Elimina la propiedad especialidades para no cargarlo
            const userData = { ...response.data.datos };
            delete userData.especialidades;
            delete userData.token;
            delete userData.update;

            localStorage.setItem("userData", JSON.stringify(userData));
            localStorage.setItem('tokenAuth', response.data.datos.token)
            localStorage.setItem("aut", this.rol);
          }

        }


      } catch (error) {
        const mensaje = error?.response?.data?.message
          || "No se pudo conectar con el servidor.";
        this.showErrorToast(mensaje);
        console.log(error);
      }

    },

    confirmar() {
      this.acceptingTerms = true;
      document.getElementById("btn-terms").innerHTML =
        '<i class="fas fa-spinner fa-pulse"></i>  Aceptando...';

      if (this.selectedEspecialidad) {
        let sessionType = this.$encryptBackoffice.encrypt(this.selectedEspecialidad);
        localStorage.setItem("session", sessionType); //envio la especialidad encriptada
        let userData = JSON.parse(localStorage.getItem("userData"));
        userData.especialidad = this.selectedEspecialidad;
        localStorage.setItem("userData", JSON.stringify(userData));

        this.$router.push({ name: 'Dashboard' })

      }

    }



  },
  async mounted() {



  },
  created() { },
  beforeUnmount() { },
};
</script>

<style scoped>
.login-form {
  width: 100%;
  margin-top: 0.75rem;
}

.login-form__title {
  margin: 0 0 0.85rem;
  text-align: center;
  font-size: 1.05rem;
  font-weight: 700;
}

.login-form__hint {
  position: relative;
  margin-bottom: 1rem;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
}

.login-form__hint i {
  margin-left: 0.2rem;
  font-size: 15px;
  cursor: pointer;
}

.login-form__tooltip {
  position: absolute;
  left: 0;
  right: 0;
  bottom: calc(100% + 8px);
  z-index: 5;
  padding: 10px;
  border-radius: 8px;
  background-color: #333333;
  color: #fdfdfd;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  text-align: left;
}

.login-form .form-control {
  width: 100%;
}

.login-form__submit {
  width: 100%;
  background: #0078be !important;
}

.bg-gradient-success {
  background-image: linear-gradient(310deg, #08629e 0%, #0c75ba 100%);
}

.m-input.--md .m-input-input,
.m-input.--md .m-input-label {
  font-size: 12px !important;
  line-height: 1.5rem;
}

.btn:disabled,
.btn.disabled,
fieldset:disabled .btn {
  cursor: not-allowed;
  pointer-events: auto;
}

.cardForm {
  margin: 1rem;
  padding: 1rem;
  /* border: 1px solid #ddd; */
  border-radius: 0.5rem;
  cursor: pointer;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
}

.cardForm:hover {
  background-color: rgb(251, 251, 251);
}

.cardForm-text {
  font-weight: 600;
}

.cardForm-body {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
}

.selected {
  background-color: rgb(126,
      12,
      126,
      0.12);
  /* Change this to the color you want for selected cardForms */
}

.selected:hover {
  background-color: rgb(126,
      12,
      126,
      0.12);
  /* Change this to the color you want for selected cardForms */
}

.tooltip {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.tooltip .tooltiptext {
  visibility: visible;
  /* Change to visible for debugging */
  opacity: 1;
  /* Change to 1 for debugging */
  width: 200px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -100px;
  transition: opacity 0.3s;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}
</style>
